var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c('router-view',{key:'clubs' + _vm.$route.params.clubId ? _vm.$route.params.clubId : 'list'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }